import React from "react";

export default function YoutubeFallback() {
  return <div className="w-[80%] h-[20rem] bg-gray-200 animate-glare"></div>;
}
